import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class ArchingService {
    SearchArchings = async (filters, branchId) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            branchId
        })
        return await HttpClient.Get(`/api/Archings?${queryString}`);
    }

    GetByArchingId = async (archingId) => {
        return await HttpClient.Get(`/api/Archings/${archingId}`)
    }

    CreateArching = async (arching) => {
        return await HttpClient.Post('/api/archings', arching)
    }

    GetArchingComprobant = async (filters, branchId) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            branchId
        })
        return await HttpClient.Get(`/api/Archings/GetArchingComprobant?${queryString}`);
    }
}

export default new ArchingService();